export type ClientWorkspace = {
  code: "US" | "DE" | "FR";
  marketCode: "US" | "DE" | "FR";
  localeCode: "en-US" | "de-DE" | "fr-FR";
  currency: "USD" | "EUR";
  timezone: "America/New_York" | "Europe/Berlin" | "Europe/Paris";
  productCodes: string[];
  customerLabel: string;
  marketLabel: string;
  storefrontDomain: string;
  localized: boolean;
  contentLanguageLabel: string;
  defaultContentCategory: string;
};

const host = window.location.hostname.toLowerCase();
export const WORKSPACE: ClientWorkspace = host === "s.saydian.de"
  ? { code: "DE", marketCode: "DE", localeCode: "de-DE", currency: "EUR", timezone: "Europe/Berlin", productCodes: ["W9S"], customerLabel: "德国德语 · W9S", marketLabel: "德国", storefrontDomain: "saydian.de", localized: true, contentLanguageLabel: "德语", defaultContentCategory: "Gesundheitswissen" }
  : host === "fros.saydian.com"
    ? { code: "FR", marketCode: "FR", localeCode: "fr-FR", currency: "EUR", timezone: "Europe/Paris", productCodes: ["E8", "R7", "W9S"], customerLabel: "法国法语 · E8 / R7 / W9S", marketLabel: "法国", storefrontDomain: "fr.saydian.com", localized: true, contentLanguageLabel: "法语", defaultContentCategory: "Conseils bien-être" }
    : { code: "US", marketCode: "US", localeCode: "en-US", currency: "USD", timezone: "America/New_York", productCodes: ["E8", "R7", "W9S"], customerLabel: "US英语 · E8 / R7 / W9S", marketLabel: "美国", storefrontDomain: "www.saydian.com", localized: false, contentLanguageLabel: "英文", defaultContentCategory: "General" };

export const workspaceField = () => ({ marketCode: WORKSPACE.marketCode, localeCode: WORKSPACE.localeCode, currency: WORKSPACE.currency });
